// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Sw5e","addWidgetButton":"Header_addWidgetButton__1w5E4","dashboardTabs":"Header_dashboardTabs__a_lDV","active":"Header_active__2VEwZ"};